import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import AppleIcon from "@mui/icons-material/Apple";
import PhoneIphoneRoundedIcon from "@mui/icons-material/PhoneIphoneRounded";
import ColourConstants from "helpers/colourConstants";
import { headerDateFormatLastLogin } from "helpers/date";
import {
	getLastMobileConnectionLabel,
	getDeviceLabel,
} from "helpers/mobileVersion";

const media = "@media (max-width: 414px)";

const useStyles = makeStyles()((theme) => ({
	historyContainer: {
		// marginTop: 10,
		// marginBottom: 10,
		paddingLeft: 2,
		display: "flex",
		gap: "20px",
		[media]: {
			display: "block",
			width: "100%",
		},
	},
	historyText: {
		display: "flex",
		color: ColourConstants.commonText,
	},
	lastSaved: {
		fontWeight: "bold",
		paddingRight: 8,
		fontSize: "14px",
	},
	timestampSize: {
		fontSize: "14px",
	},
	deviceIcon: {
		fontSize: 16,
		marginRight: 4,
		verticalAlign: "middle",
		position: "relative",
		top: -2,
	},
}));

const SaveHistory = ({
	hideLastLogin = false,
	hideLastSave = false,
	hideVersion = true,
	versionNumber,
	lastLogin,
	lastMobileAppVersion,
	lastMobileAppBuild,
	lastMobileSeen,
	hasMobileLogin,
	lastMobileDeviceModel,
	lastMobileOSVersion,
}) => {
	const { t } = useTranslation();
	const { classes } = useStyles();
	const [lastSave, setLastSave] = useState("");

	useEffect(() => {
		if (lastLogin) {
			const date = headerDateFormatLastLogin(lastLogin);
			setLastSave(date);
		}
	}, [lastLogin]);

	const lastMobileConnection = getLastMobileConnectionLabel({
		lastMobileAppVersion,
		lastMobileAppBuild,
		lastMobileSeen,
		hasMobileLogin,
	});

	const deviceLabel = getDeviceLabel({
		lastMobileDeviceModel,
		lastMobileOSVersion,
	});

	const DeviceIcon = lastMobileDeviceModel?.startsWith("iPad")
		? AppleIcon
		: PhoneIphoneRoundedIcon;

	return (
		<div className={`${classes.historyContainer} mt-sm`}>
			{hideLastSave ? null : (
				<div className={classes.historyText}>
					<Typography className={classes.lastSaved}>{t("label.lastSaved")}</Typography>
					<Typography className={classes.timestampSize}>{lastSave}</Typography>
				</div>
			)}
			{hideLastLogin ? null : (
				<div className={classes.historyText}>
					<Typography className={classes.lastSaved}>{t("label.lastLogin")}</Typography>
					<Typography className={classes.timestampSize}>{lastSave}</Typography>
				</div>
			)}
			{hideLastLogin || !lastMobileConnection ? null : (
				<div className={classes.historyText}>
					<Typography className={classes.lastSaved}>
						Last mobile connection:
					</Typography>
					<Typography className={classes.timestampSize}>
						{deviceLabel ? (
							<Tooltip title={deviceLabel} arrow>
								<DeviceIcon className={classes.deviceIcon} />
							</Tooltip>
						) : null}
						{lastMobileConnection}
					</Typography>
				</div>
			)}
			{hideVersion ? null : (
				<div className={classes.historyText}>
					<Typography className={classes.lastSaved}>{t("label.version")}</Typography>
					<Typography className={classes.timestampSize}>
						{versionNumber ?? 1}
					</Typography>
				</div>
			)}
		</div>
	);
};

export default SaveHistory;
